import { useCallback, useEffect, useState } from 'react';
import { useSessionContext } from '../../context/SessionContext';
import { log } from '../../tools/LogHelper';

/**
 * Publish and/or subscribe to when a new message occurs
 * @param roomId
 * @param shouldSubscribe
 */
export function usePubSubNewMessages(component = '', shouldSubscribe = false) {
  const [refreshToken, setRefreshToken] = useState<string>();
  const { publish, subscribe, unsubscribe } = useSessionContext();
  const key = `/rooms/new-message`;
  useEffect(() => {
    const callback = (refreshToken: string) => {
      log('pubSubNewMessages', refreshToken);
      setRefreshToken(refreshToken);
    };
    if (shouldSubscribe) {
      subscribe(key, component, callback);
      return () => unsubscribe(key, component, callback);
    }
  }, [key, component, shouldSubscribe, subscribe, unsubscribe]);
  const notifyNewMessage = useCallback(() => {
    publish(key, new Date().toString());
  }, [key, publish]);
  return {
    refreshToken,
    notifyNewMessage
  };
}
